import {
	LOAD_USERS,
	ADD_USER,
	UPDATE_USER,
	DELETE_USER,
	GET_ACTIVE_USER,
	UPDATE_ACTIVE_USER,
	SET_ALL_USERS,
	CHANGE_PASSWORD_MESSAGE,
} from "../users/usersConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialUsersState = {
	allUsers: [],
};

const initialChangePasswordState={
	changePasswordMessage: ""
}

export default function (state, { type, payload }) {
	switch (type) {
		case LOAD_USERS:
			return { users: payload };
		case ADD_USER:
			return { users: [...state.users, payload] };
		case UPDATE_USER: {
			const userToUpdate = state.users.find((user) => user.id === payload.id);
			return {
				users: [
					...state.users.filter((user) => user.id !== payload.id),
					Object.assign({}, userToUpdate, { payload }),
				],
			};
		}
		case DELETE_USER:
			return { users: state.users.filter((user) => user.id !== payload) };
		default:
			return state;
	}
}

export function authenticateUserHasErrored(state = false, action) {
	switch (action.type) {
		case "AUTHENTICATE_USER_HAS_ERRORED":
			return action.hasErrored;
		default:
			return state;
	}
}
export function authenticateUserIsLoading(state = false, action) {
	switch (action.type) {
		case "AUTHENTICATE_USER_IS_LOADING":
			return action.isLoading;
		default:
			return state;
	}
}
export function authenticatedUser(state = [], action) {
	switch (action.type) {
		case "AUTHENTICATE_USER_SUCCESS":
			return action.user;
		default:
			return state;
	}
}

export function activeUser(state = [], action) {
	switch (action.type) {
		case GET_ACTIVE_USER:
			if (!action.user) {
				return null;
			}
			return action.user;
		case UPDATE_ACTIVE_USER:
			if (!action.user) {
				return state;
			}
			return action.user;
		default:
			return state;
	}
}

export function users(state = initialUsersState, action) {
	switch (action.type) {
		case SET_ALL_USERS:
			return setValue(state, ["allUsers"], action.users);
		default:
			return state;
	}
}

export function changePassword(state = initialChangePasswordState, action) {
	switch (action.type) {
		case CHANGE_PASSWORD_MESSAGE:
			return setValue(state, ["changePasswordMessage"], action.changePasswordMessage);
		default:
			return state;
	}
}